import React, { useState, useEffect, useCallback } from "react";
import { TextField, Button, Checkbox, FormControlLabel, Typography, Box, Paper, IconButton } from "@mui/material";
import { useAuth } from "../Context/AuthProvider"; // Assuming you have this context
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { loginUser, validateToken, getUserProfile } from "../http/api";
import { loginUser, validateToken } from "../http/api";
import { useGlobalState } from '../Context/GlobalContext';
import { tokens, withAlpha } from '../Common/designTokens'; // added

const LoginPage = () => {
  
  const {userName, passWord, tgRoute, rLogin, updateUserName, updatePassWord, updateRLogin} = useGlobalState();
  const [username, setUsername] = useState(userName);
  const [password, setPassword] = useState(passWord);
  const [error, setError] = useState("");
  const {setlogin, setProfile } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveUserId, setSaveUserId] = useState(false);
  const navigate = useNavigate();
  const tRoute = `/${tgRoute}`;
  

  // Auto-fill username if saved in localStorage on mount
  useEffect(() => {
  
    const savedUID = localStorage.getItem("savedUserId");
    if (savedUID) {
      setUsername(savedUID);
      setSaveUserId(true);
    }
  }, []);

  // Redirect if an existing valid session is found.
  useEffect(() => {
  
    const checkSession = async () => {
      const token = localStorage.getItem("token");
      if (token && (await validateToken(token))) {
        try {
          // Fetch profile information if token is valid
          // const profileData = await getUserProfile(token);
          // setProfile(profileData);
        } catch (error) {
          console.error("Failed to fetch profile:", error);
        }
        
        navigate(tRoute);
      }
    };
    checkSession();
  }, [navigate, setProfile, tRoute]);

  // const handleLogin = async (e) => {
  //   if(e) {
  //     e.preventDefault();
  //   }
    
  //   const sanitizedUsername = username.trim();
  //   // Validate username length
  //   if (sanitizedUsername.length < 3 || sanitizedUsername.length > 20) {
  //     setError("Username must be between 3 and 20 characters");
  //     return;
  //   }
  //   // Validate allowed characters: alphanumeric, hyphen, underscore
  //   if (!/^[A-Za-z0-9_-]+$/.test(sanitizedUsername)) {
  //     setError("Username can only contain alphanumeric characters, hyphen, and underscore");
  //     return;
  //   }
  //   if (!sanitizedUsername || !password) {
  //     setError("Username and password are required");
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const data = await loginUser(sanitizedUsername, password);
  //     setlogin(data);
      
  //     try {
  //       // Fetch user profile after successful login
  //       // const profileData = await getUserProfile(data.token);
  //       // setProfile(profileData);
  //     } catch (profileError) {
  //       console.error("Failed to fetch profile:", profileError);
  //     }
      
  //     // Save user id if checkbox is checked; remove if not
  //     if (saveUserId) {
  //       localStorage.setItem("savedUserId", sanitizedUsername);
  //     } else {
  //       localStorage.removeItem("savedUserId");
  //     }
  //     navigate("/order");
  //   } catch (error) {
  //     if (error.message === "Failed to fetch") {
  //       setError("Network error. Please try again later.");
  //     } else {
  //       setError(error.message);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleLogin = useCallback(async (e) => {
    if(e) {
      e.preventDefault();
    }
    
    const sanitizedUsername = username.trim();
    // Validate username length
    if (sanitizedUsername.length < 3 || sanitizedUsername.length > 20) {
      setError("Username must be between 3 and 20 characters");
      return;
    }
    // Validate allowed characters: alphanumeric, hyphen, underscore
    if (!/^[A-Za-z0-9_-]+$/.test(sanitizedUsername)) {
      setError("Username can only contain alphanumeric characters, hyphen, and underscore");
      return;
    }
    if (!sanitizedUsername || !password) {
      setError("Username and password are required");
      return;
    }

    setIsLoading(true);

    try {
      const data = await loginUser(sanitizedUsername, password);
      setlogin(data);
      
      try {
        // Fetch user profile after successful login
        // const profileData = await getUserProfile(data.token);
        // setProfile(profileData);
      } catch (profileError) {
        console.error("Failed to fetch profile:", profileError);
      }
      
      // Save user id if checkbox is checked; remove if not
      if (saveUserId) {
        localStorage.setItem("savedUserId", sanitizedUsername);
      } else {
        localStorage.removeItem("savedUserId");
      }
      
      navigate(tRoute);
    } catch (error) {
      if (error.message === "Failed to fetch") {
        setError("Network error. Please try again later.");
      } else {
        setError(error.message);
      }
    } finally {
      setIsLoading(false);
    }
  }, [tRoute, username, password, setError, setIsLoading, navigate, setlogin, saveUserId]);  

  useEffect(() => {
    
    if(rLogin) {
      handleLogin();
      updateUserName("");
      updatePassWord("");
      updateRLogin(false);
    }        
  }, [rLogin, handleLogin, updatePassWord, updateUserName, updateRLogin]);

  // const displayMode = (rMode) ? "none" : "flex";
  const displayMode = "flex";

  return (
    <Box 
      sx={{ 
        minHeight: "100vh",
        display: displayMode,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: tokens.colors.bodyBackgroundColor,
        padding: "20px"
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "440px",
          backgroundColor: tokens.colors.defaultGridRowColor,
          color: tokens.colors.fontColour,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "50px",
          gap: "12px",
          borderRadius: "8px",
          border: `1px solid ${tokens.colors.bodyBorderColor50}`,
        }}
      >
        <Box component="img" src="/CoPilot_Logo.svg" alt="Co-Pilot Logo" sx={{ width: 140, height: 'auto', }} />
        <Typography sx={{mt:4,mb:0}} variant="h5">Log In to Co-Pilot</Typography>
        <Box component="form" noValidate onSubmit={handleLogin} sx={{ mt:0,width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <TextField
            fullWidth
            variant="outlined"
            label="Username"
            autoComplete="off"
            margin="normal"
            placeholder="Enter your username"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                '& fieldset': { borderColor: tokens.colors.bodyBorderColor50 },
                '&:hover fieldset': { borderColor: tokens.colors.bodyBorderColor50 },
                '&.Mui-focused fieldset': { borderColor: tokens.palette.primary },
                backgroundColor: tokens.colors.white,
              },
              '& .MuiInputBase-input': { color: tokens.colors.fontColour },
              '& .MuiInputLabel-root': { color: tokens.colors.fontColour85 },
            }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            autoComplete="off"
            label="Password"
            placeholder="Enter your password"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                '& fieldset': { borderColor: tokens.colors.bodyBorderColor50 },
                '&:hover fieldset': { borderColor: tokens.colors.bodyBorderColor50 },
                '&.Mui-focused fieldset': { borderColor: tokens.palette.primary },
                backgroundColor: tokens.colors.white,
              },
              '& .MuiInputBase-input': { color: tokens.colors.fontColour },
              '& .MuiInputLabel-root': { color: tokens.colors.fontColour85 },
            }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  sx={{ color: tokens.colors.fontColour }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={saveUserId}
                onChange={(e) => setSaveUserId(e.target.checked)}
              />
            }
            label="Save User ID on this device"
            sx={{ color: tokens.colors.fontColour85 }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
            sx={{
              height: '48px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 700,
              marginTop: '8px',
              '&.Mui-disabled': {
                backgroundColor: tokens.colors.disabledBackground,
                color: tokens.colors.disabledFontColour,
              }
            }}
          >
            {isLoading ? "Logging in..." : "Log In"}
          </Button>
        </Box>
        {error && (
          <Typography variant="body2" sx={{ color: tokens.palette.danger, textAlign: "center" }}>
            {error}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default LoginPage;